import { get, patch } from "@shared/utils/api";

const PROFILE_PATH = "/api/v1/auth/profile";

/**
 * Fetch current user profile (email, given_name, family_name, phone_number).
 * Requires session with Cognito access token (email/password login).
 * @returns {Promise<{ email: string, given_name: string, family_name: string, phone_number: string }>}
 * @throws On non-OK response, response body may contain { error }.
 */
export async function fetchProfile() {
  const res = await get(PROFILE_PATH);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.error || "Unable to load profile.");
    err.status = res.status;
    err.body = data;
    throw err;
  }
  return data;
}

/**
 * Update profile (given_name, family_name, phone_number). Email is read-only.
 * @param {{ given_name?: string, family_name?: string, phone_number?: string }} data
 * @returns {Promise<{ email: string, given_name: string, family_name: string, phone_number: string }>}
 */
export async function updateProfile(data) {
  const res = await patch(PROFILE_PATH, data);
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body?.error || "Unable to update profile.");
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}
